import { render, staticRenderFns } from "./ReportIntroduction.vue?vue&type=template&id=0f9a7031&lang=pug&"
import script from "./ReportIntroduction.vue?vue&type=script&lang=ts&"
export * from "./ReportIntroduction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports